import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { PlanSuggestionInfo, AccountTrialStatus, AccountTierFields, AccountRoleInfo, AccountManagedByAdobe, AccountOwner, SubscriptionInfo, AccountLockingInfo, AccountPlanAndTrialInfo } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetCurrentPlanQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetCurrentPlanQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, managedBy?: Types.AccountManagementTypes | null, owner?: { __typename?: 'Owner', id: string, email: string } | null, subscription: { __typename?: 'AccountSubscription', discountOfferExpiresAt?: string | null, id: string, cancelledAt?: string | null, isLegacy?: boolean | null, cost?: number | null, nextBillAt?: string | null, pauseOfferExpiresAt?: string | null, period: Types.SubscriptionPeriod, subscriptionEndAt?: string | null, tier: Types.AccountTier, title: string, balance: number, plan?: { __typename?: 'Plan', cost: number, id: string, name?: string | null, paymentMethod: Types.PlanPaymentMethod, period: Types.PlanPeriod, tier: Types.PlanTier, version?: number | null, activeStorageLimit?: number | null, archivedStorageLimit?: number | null, title: string, eligibility: Types.PlanEligibility, mountedStorageLimit?: number | null, userLimit?: number | null, userMax?: number | null, perUserStorageIncrement?: number | null, availableFeatures: { __typename?: 'AvailableFeatures', id: string, mountedStorage: boolean, mountedStorageOverprovisioningAllowed: boolean }, addOns?: Array<{ __typename?: 'PlanAddOn', id: string, modifier?: string | null }> | null } | null, trial: { __typename?: 'SubscriptionTrial', isActive: boolean, promotionExpiresAt?: string | null }, addOns?: Array<{ __typename?: 'AddOn', cost: number, id: string, increment: number, modifier: string, quantity: number }> | null, limitedResources?: { __typename?: 'LimitedResources', archivedStorageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, mountedStorageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, projects?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, storageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, workspaces?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null } | null, perUserStorage?: { __typename?: 'AccountSubscriptionPerUserStorage', seats: number, increment: number, limit: number } | null }, usageByLicenseType: { __typename?: 'SeatUsageByLicenseTypeMapping', guest?: { __typename?: 'SeatUsage', availableSeats?: number | null, seatLimit?: number | null } | null }, role?: { __typename?: 'Role', id: string, name: string } | null } | null };


export const GetCurrentPlan = /*#__PURE__*/ gql`
    query GetCurrentPlan($accountId: ID!) {
  account(accountId: $accountId) {
    ...AccountPlanAndTrialInfo
    ...AccountRoleInfo
    id
    managedBy
    owner {
      id
      email
    }
    subscription {
      ...SubscriptionInfo
    }
    usageByLicenseType {
      guest {
        availableSeats
        seatLimit
      }
    }
  }
}
    ${AccountPlanAndTrialInfo}
${AccountRoleInfo}
${SubscriptionInfo}` as unknown as DocumentNode<GetCurrentPlanQuery, GetCurrentPlanQueryVariables>;

          

          export const useGetCurrentPlanQuery = (options?:QueryHookOptions<GetCurrentPlanQuery, GetCurrentPlanQueryVariables>) => useQuery(GetCurrentPlan, options);

          

          export type GetCurrentPlanQueryOptions = QueryHookOptions<GetCurrentPlanQuery, GetCurrentPlanQueryVariables>;

          

          export const useGetCurrentPlanLazyQuery = (options?:LazyQueryHookOptions<GetCurrentPlanQuery, GetCurrentPlanQueryVariables>) => useLazyQuery(GetCurrentPlan, options);

          

          export type GetCurrentPlanQueryResult = ReturnType<typeof useGetCurrentPlanQuery>;

          
